import {
    storageListSelect,
    pageVoucher,
    delVoucher,
    inboundDelete,
    outboundDelete,
    storageAllDelete,
    combindDelete,
    financePaymentDelete,
    financeOrderDelete,
    otherExpendDelete,
    otherIncomeDelete,
    updateauditState,
    operatePass,
    abandonstate
} from "@/utils/api"
export const orderList = {
    data() {
        return {
            itemOrder: {},
            queryObj: {},
            buttonList:[]
        }
    },
    methods: {

        //废弃
        onDeleteOrder(record, index) {
            let data = new FormData()
            data.append('companyStoreId', this.$store.state.shopId)
            data.append('voucherEntityId', this.detailId)
            abandonstate(data, {}, {}).then((res) => {
                if (res.success) {
                    this.$store.state.closePath = this.$route.fullPath
                    this.$message.success(res.logMessage)
                } else {
                    this.$message.warn(res.logMessage)
                }
            })
        },
        //审核通过   审核拒绝
        onConfirmOrderObj(record) {
            console.log(record)
                // 20 审核通过  21 拒绝  22再次申请
            if (this.itemOrder.id == 20) {
                operatePass({
                    code: record.code,
                    companyStoreId: this.$store.state.shopId,
                    operationData: record.value,
                    operationType: 1,
                    voucherId: record.voucherEntityId,
                    voucherType: record.type,
                }, {}, {}).then((res) => {
                    if (res.success) {
                        this.$store.state.closePath = this.$route.fullPath
                        this.$message.success('审核通过')
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            } else if (this.itemOrder.id == 21) {
                operatePass({
                    code: record.code,
                    companyStoreId: this.$store.state.shopId,
                    operationData: record.value,
                    operationType: 2,
                    voucherId: record.voucherEntityId,
                    voucherType: record.type,
                }, {}, {}).then((res) => {
                    if (res.success) {
                        this.$store.state.closePath = this.$route.fullPath
                        this.$message.success(res.logMessage)
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            }
        },
        //撤销草稿
        btnOkSave(index) {
            let that = this
            if (index == 3) {
                let data = new FormData()
                data.append('companyStoreId', this.$store.state.shopId)
                data.append('voucherEntityId', this.detailId)
                updateauditState(data, {}, {}).then((res) => {
                    if (res.success) {
                        // this.$store.state.closePath = this.$route.fullPath
                        this.$message.success('撤回成功')
                        if (that.$route.path == '/bill/modules/billIncome') {
                            that.$router.push('/finance/voucher/otherRevenueEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/billProceeds') {
                            that.$router.push('/finance/voucher/receiptOrderEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/billPayment') {
                            that.$router.push('/finance/voucher/paymentOrderEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/billDisburse') {
                            that.$router.push('/finance/voucher/otherExpensesEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/warehouseDetail') {
                            that.$router.push('/librarymanage/warehousemanage/warehousemanageEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/assemblyDetail') {
                            that.$router.push('/librarymanage/warehousemanage/assemblyDisEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/billElseStorage') {
                            that.$router.push('/librarymanage/warehousemanage/OtheerWarehousingEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/lossDetail') {
                            that.$router.push('/librarymanage/warehousemanage/InventoryLossReportEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/overflowDetail') {
                            that.$router.push('/librarymanage/warehousemanage/InventoryOverflowEdit?id=' + that.detailId)
                        } else if (that.$route.path == '/bill/modules/billElseWarehouse') {
                            that.$router.push('/librarymanage/warehousemanage/OtheerWarehouEdit?id=' + that.detailId)
                        }
                    } else {
                        this.$message.warn(res.logMessage)
                    }
                })
            }
        },
        getInit(index) {

            //1 调拨 2报损 3 报溢 4其他入库  5其他出库  6组转拆卸 7其他支出 8其他收入 9收款单 10付款单 
            if (this.queryObj.reverseFlag == 2) {
                this.buttonList = []
                this.getButtonPrit(index)
            } else if (this.queryObj.reverseFlag == 1) {
                if (index == 1) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'library_warehouse_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 401,
                        has:'library_warehouse_bill_print'
                    }]
                } else if (index == 2) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'library_loss_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 402,
                        has:'library_loss_bill_print'
                    }]
                } else if (index == 3) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'library_overflow_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 403,
                        has:'library_overflow_bill_print'
                    }]
                } else if (index == 4) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'library_other_enter_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 405,
                        has:'library_other_enter_bill_print'
                    }]
                } else if (index == 5) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'library_other_out_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 406,
                        has:'library_other_out_bill_print'
                    }]
                } else if (index == 6) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'library_assembly_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 407,
                        has:'library_assemblye_bill_print'
                    }]
                } else if (index == 7) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'finance_other_expenses_enter_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 301,
                        has:'finance_other_expenses_bill_print'
                    }]
                } else if (index == 8) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'finance_other_revenue_enter_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 302,
                        has:'finance_other_revenue_bill_print'
                    }]
                } else if (index == 9) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'finance_receipt_enter_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 303,
                        has:'finance_receipt_bill_print'
                    }]
                } else if (index == 10) {
                    this.buttonList = [{
                        id: 5,
                        text: '红冲',
                        has:'finance_payment_enter_hong',
                    },{
                        id: 7,
                        text: "打印",
                        templateType: 304,
                        has:'finance_payment_bill_print'
                    }]
                } else {
                    this.buttonList.push({
                        id: 7,
                        text: "打印",
                    })
                }
            }
            if (this.queryObj.deletId == 1) {
                this.buttonList = [{
                    id: 19,
                    text: '删除',
                }]
            }
            //1  审批者   2 被审批者  3，参与的没有审核这两个按钮
            if (this.queryObj.orderId == 1) {
                if (index == 1) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'library_warehouse_audit'
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'library_warehouse_audit'
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 401,
                            has:'library_warehouse_bill_print'
                        }
                    ]
                } else if (index == 2) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'library_loss_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'library_loss_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 402,
                            has:'library_loss_bill_print',
                        }
                    ]
                } else if (index == 3) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'library_overflow_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'library_overflow_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 403,
                            has:'library_overflow_bill_print',
                        }
                    ]
                } else if (index == 4) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'library_other_enter_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'library_other_enter_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 405,
                            has:'library__other_enter_bill_print',
                        }
                    ]
                } else if (index == 5) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'library_other_out_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'library_other_out_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 406,
                            has:'library_other_out_bill_print',
                        }
                    ]
                } else if (index == 6) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'library_assembly_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'library_assembly_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 407,
                            has:'library_assemblye_bill_print',
                        }
                    ]
                } else if (index == 7) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'finance_other_expenses_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'finance_other_expenses_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 301,
                            has:'finance_other_expenses_bill_print'
                        }
                    ]
                } else if (index == 8) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'finance_other_revenue_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'finance_other_revenue_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 302,
                            has:'finance_other_revenue_bill_print'
                        }
                    ]
                } else if (index == 9) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'finance_receipt_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'finance_receipt_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 303,
                            has:'finance_receipt_bill_print'
                        }
                    ]
                } else if (index == 10) {
                    this.buttonList = [{
                            id: '20',
                            text: '审核通过',
                            has:'finance_payment_audit',
                        },
                        {
                            id: '21',
                            text: '不通过',
                            has:'finance_payment_audit',
                        },
                        {
                            id: 7,
                            text: "打印",
                            templateType: 304,
                            has:'finance_receipt_bill_print'
                        }
                    ]
                } else {
                    this.buttonList.push({
                        id: 7,
                        text: "打印",
                    })
                }
            } else if (this.queryObj.orderId == 2) {
                //第一次拒绝
                if (this.queryObj.approvalState == 2) {
                    this.buttonList = [{
                            id: '22',
                            text: '再次申请'
                        },
                        {
                            id: '19',
                            text: '废弃'
                        },
                    ]
                    this.getButtonPrit(index)
                    //第二次拒绝  关闭
                } else if (this.queryObj.approvalState == 3) {
                    this.buttonList = []
                    this.getButtonPrit(index)
                } else if (this.queryObj.approvalState == 0) {
                    this.buttonList = [{
                            id: '23',
                            text: '撤回编辑'
                        },
                        // {
                        //     id:'19',
                        //     text:'废弃'
                        // },
                    ]
                    this.getButtonPrit(index)
                } else {
                    this.buttonList = []
                    this.getButtonPrit(index)
                }
            } else if (this.queryObj.orderId == 3) {
                this.buttonList = []
                this.getButtonPrit(index)
            }
        },
        getButtonPrit(index){
            if (index == 1) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 401,
                    has:'library_warehouse_bill_print'
                })
            } else if (index == 2) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 402,
                    has:'library_loss_bill_print'
                })
            } else if (index == 3) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 403,
                    has:'library_overflow_bill_print'
                })
            } else if (index == 4) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 405,
                    has:'library__other_enter_bill_print'
                })
            } else if (index == 5) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 406,
                    has:'library_other_out_bill_print'
                })
            } else if (index == 6) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 407,
                    has:'library_assemblye_bill_print'
                })
            } else if (index == 7) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 301,
                    has:'finance_other_expenses_bill_print'
                })
            } else if (index == 8) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 302,
                    has:'finance_other_revenue_bill_print'
                })
            } else if (index == 9) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 303,
                    has:'finance_receipt_bill_print'
                })
            } else if (index == 10) {
                this.buttonList.push({
                    id: 7,
                    text: "打印",
                    templateType: 304,
                    has:'finance_payment_bill_print'
                })
            } else {
                this.buttonList.push({
                    id: 7,
                    text: '打印'
                })
            }
        }
    }

}